"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElasticsearchClient = exports.ElasticsearchURLEnum = void 0;
const tslib_1 = require("tslib");
const getUserAWSClient_1 = require("./getUserAWSClient");
var ElasticsearchURLEnum;
(function (ElasticsearchURLEnum) {
    ElasticsearchURLEnum["ES_AZURE_URL"] = "https://new-dev-api.lyearn.com";
    ElasticsearchURLEnum["ES_AWS_URL"] = "https://search-lyearn-user-es-6luna2pnb2j2st3c426kwtxgtu.us-east-1.es.amazonaws.com";
})(ElasticsearchURLEnum = exports.ElasticsearchURLEnum || (exports.ElasticsearchURLEnum = {}));
function getElasticsearchClient(elasctisearchUrl) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        return getUserAWSClient_1.getUserAWSClient(elasctisearchUrl);
    });
}
exports.getElasticsearchClient = getElasticsearchClient;
//# sourceMappingURL=index.js.map